/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import { _initialState } from '../_initialState';
import logNewRelicCustom from '../../../utils/logNewRelicCustom';
import { NEW_RELIC_EVENTS } from '../../../constants';

export default (set, get) => {
  return set(produce(get(), (draft) => {
    if (!draft.design) {
      draft.design = {};
    }

    const logValues = {
      designId: draft.design.designId || '00000000-0000-0000-0000-000000000000',
      ...(draft.design?.isFromPip && { isFromPip: true })
    };

    logNewRelicCustom(NEW_RELIC_EVENTS.DESIGN_RESTART, logValues);
    draft.design.products = _initialState.design.products;
    draft.design.cart = _initialState.design.cart;
    draft.design.selectedProduct = null;
    draft.bundles.added = _initialState.bundles.added;
  }), false, { type: 'RESET' });
};
